import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Quote } from "lucide-react";

export const TESTIMONIALS = [
  {
    id: "marie-danielle",
    name: "Marie-Danielle J.",
    role: "Infirmière · Montréal, Québec",
    lang: "Français",
    text: "J'ai grandi à Montréal en entendant qu'il ne fallait pas parler du Vodou. Ce parcours m'a rendu ce qu'on m'avait enlevé : la fierté. La séance sur les Taïnos et Anacaona m'a bouleversée — j'ai appelé ma grand-mère le soir même pour lui poser des questions que je n'avais jamais osé poser.",
  },
  {
    id: "kettly",
    name: "Kettly S.",
    role: "Travailleuse sociale · Brooklyn, New York",
    lang: "Kreyòl",
    text: "Fòmasyon sa a chanje jan mwen wè tèt mwen. Mwen te konn wont pale de Vodou — kounye a mwen konprann se yon eritaj rezistans, yon fòs. Egzèsis « Kisa Vodou vle di pou ou » a te fè m kriye. Mèsi Manbo Sèlide ak tout ekip la. Ayibobo !",
  },
  {
    id: "stephane",
    name: "Stéphane L.",
    role: "Enseignant d'histoire · Québec",
    lang: "Français",
    text: "Je ne suis pas d'origine haïtienne, et je cherchais une formation rigoureuse, sans folklore ni sensationnalisme. J'ai trouvé une pédagogie décoloniale exigeante : chronologies, sources, nuances. La séance sur Bois Caïman devrait être enseignée dans toutes les écoles.",
  },
  {
    id: "nathalie",
    name: "Nathalie C.",
    role: "Doctorante en anthropologie · Paris",
    lang: "Français",
    text: "La distinction que fait la formation entre le savoir public et ce qui demeure réservé aux initiés est d'une grande justesse éthique. On apprend énormément — le panthéon, les nanchon, le Fa — tout en apprenant le respect des limites. C'est rare et précieux.",
  },
  {
    id: "jean-robert",
    name: "Jean-Robert P.",
    role: "Musicien · Port-au-Prince, Haïti",
    lang: "Français",
    text: "Le module d'écoute des rythmes Rada et Nago m'a donné des mots pour ce que je joue depuis l'enfance. Comprendre que le yanvalou est une grammaire liturgique, pas juste un rythme — sa chanje tout bagay. Je recommande à tous les musiciens de la diaspora.",
  },
  {
    id: "fabiola",
    name: "Fabiola M.",
    role: "Entrepreneure · Lascahobas / Montréal",
    lang: "Français",
    text: "Née à Lascahobas, je connais le Lakou Impérial Savann Karé depuis toujours. Voir cette transmission portée avec autant de rigueur et d'amour en ligne, accessible à mes enfants nés au Canada, m'a émue aux larmes. J'attends la retraite en Haïti avec impatience.",
  },
];

export default function TestimonialsPage() {
  const { t } = useTranslation();

  return (
    <main className="max-w-6xl mx-auto px-6 py-16 relative z-10" data-testid="testimonials-page">
      <div className="max-w-2xl">
        <p className="text-[11px] uppercase tracking-[0.25em] text-primary" data-testid="testimonials-badge">
          {t("testimonials.badge")}
        </p>
        <h1 className="font-serif-display text-4xl sm:text-5xl mt-3 tracking-tight" data-testid="testimonials-title">
          {t("testimonials.title")}
        </h1>
        <p className="text-muted-foreground mt-4 leading-relaxed" data-testid="testimonials-subtitle">
          {t("testimonials.subtitle")}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
        {TESTIMONIALS.map((tm) => (
          <figure key={tm.id} className="bg-card border border-primary/15 rounded-lg p-7 flex flex-col" data-testid={`testimonial-${tm.id}`}>
            <Quote size={22} strokeWidth={1.5} className="text-primary/50" />
            <blockquote className="text-sm text-foreground/80 leading-relaxed mt-4 flex-1">
              « {tm.text} »
            </blockquote>
            <figcaption className="mt-6 pt-4 border-t border-primary/10">
              <p className="font-medium text-sm">{tm.name}</p>
              <p className="text-xs text-muted-foreground mt-0.5">{tm.role}</p>
            </figcaption>
          </figure>
        ))}
      </div>

      <div className="mt-14 bg-primary/5 border border-primary/25 rounded-lg p-8 text-center" data-testid="testimonials-cta">
        <p className="font-serif-display text-2xl">{t("testimonials.ctaTitle")}</p>
        <p className="text-sm text-muted-foreground mt-2 max-w-xl mx-auto">{t("testimonials.ctaText")}</p>
        <Link to="/parcours" className="inline-block mt-6 px-7 py-2.5 rounded-full bg-primary text-primary-foreground text-sm font-medium hover:bg-[#16528A] transition-colors duration-200" data-testid="testimonials-cta-btn">
          {t("hero.cta")}
        </Link>
      </div>
    </main>
  );
}
